import log from 'salvo-lite/log'

class FaqPage {
    constructor (theme, elem) {
        this._theme = theme
        this._name = this.constructor.name
        this._elem = elem
        this._faqData = JSON.parse(elem.getAttribute('faq-data') || '{}')
        this.faqs = []
        this.categories = []
        this.currentCategory = null
        this.categoryWrapper = elem.querySelector('[data-category-wrapper]')
        this.categoryContainer = elem.querySelector('[data-category-container]')
        this.faqContainer = elem.querySelector('[data-faq-container]')
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        // push this._faqData (array of strings) into a new variable Faqs (an array of objects)
        for (const faq of this._faqData) {
            const [category, question, answer] = faq.split('|')

            if (!this.categories.includes(category)) {
                this.categories.push(category)
            }

            this.faqs.push({
                category,
                question,
                answer
            })
        }

        // Set initial category:
        this.currentCategory = this.categories[0]

        // populate category and faq content using lit-html (this will be the content for the first category)
        this.renderCategories()
        this.renderFAQs()

        // Attach category event listeners
        const categoryButtons = Array.from(this._elem.querySelectorAll('.faq-page__category'))
        categoryButtons[0].classList.add('faq-page__category--active')
        for (const button of categoryButtons) {
            button.addEventListener('click', (event) => {
                event.stopPropagation()
                this.faqContainer.classList.remove('accordion--open')
                const category = button.getAttribute('data-category')
                if (category) {
                    this.currentCategory = category
                }
                // remove active class from all categories
                for (const button of categoryButtons) {
                    button.classList.remove('faq-page__category--active')
                }
                // add active class to chosen category
                button.classList.add('faq-page__category--active')
                // mobile category selector
                this.categoryWrapper.classList.remove('faq-page__categories-wrapper--expanded')
            })
        }

        // watch change on this.currentCategory and render FAQs based on value
        Object.defineProperty(this, 'currentCategory', {
            get: function () { return this._currentCategory },
            set: function (value) {
                this._currentCategory = value
                this.renderFAQs()
                this.faqDropdown()
            },
            enumerable: true,
            configurable: true
        })

        // faq dropdown functionality
        this.faqDropdown()

        // Mobile view category toggle
        this.categoryContainer.addEventListener('click', (e) => {
            if (e.target) {
                this.faqContainer.classList.remove('accordion--open')
                const clickedElement = e.target
                if (clickedElement === this.categoryContainer) {
                    this.categoryWrapper.classList.toggle('faq-page__categories-wrapper--expanded')
                }
            }
        })
    }

    renderCategories () {
        if (this.categoryContainer) {
            this.categoryContainer.innerHTML = this.categories.map(cat => categoryTemplate(cat, cat === this.currentCategory)).join('')
        }
    }

    renderFAQs () {
        const faqsToRender = this.faqs.filter((faq) => faq.category === this.currentCategory)
        if (this.faqContainer) {
            this.faqContainer.innerHTML = faqsToRender.map(faq => faqTemplate(faq)).join('')
        }
    }

    faqDropdown () {
        const faqs = this._elem.querySelectorAll('.faq-page__faq')
        if (faqs.length > 0) {
            for (const faq of faqs) {
                faq.addEventListener('click', e => {
                    this.faqContainer.classList.remove('accordion--open')
                    const section = e.target.parentElement
                    const isOpen = section.classList.contains('accordion--open')

                    for (const faq2 of faqs) {
                        faq2.classList.remove('accordion--open')
                    }

                    if (!isOpen) {
                        section.classList.add('accordion--open')
                        const accordionTop = section.getBoundingClientRect().top
                        const documentTop = document.body.getBoundingClientRect().top
                        setTimeout(() => {
                            window.scrollTo({
                                behavior: 'smooth',
                                top: accordionTop - documentTop - 200
                            })
                        }, 25)
                    }
                })
            }
        }
    }
}

export default FaqPage

/*
* Templates
***********/
const faqTemplate = (faq) => {
    return `<div
        class="accordion faq-page__faq"
        accordion-group="faqs-page"
        default-open="false"
    >
        <div class="accordion__header faq-page__question body-16" data-ref="accordionHeader">
            ${faq.question}
            <div class="faq-page__question__right">
                <div class="accordion__icon accordion__icon--plus">
                    <svg class="icon icon--caret-down" role="presentation" viewBox="0 0 21 11">
                        <polyline stroke-width="2" fill="none" stroke="currentColor"
                            points="0.5 0.5 10.5 10.5 20.5 0.5"
                        ></polyline>
                    </svg>
                </div>

                <div class="accordion__icon accordion__icon--minus">
                    <svg class="icon icon--caret-up" role="presentation" viewBox="0 0 21 11">
                        <polyline stroke-width="2" fill="none" stroke="currentColor"
                            points="20.5 10.5 10.5 0.5 0.5 10.5"
                        ></polyline>
                    </svg>
                </div>
            </div>
        </div>

        <div class="accordion__body faq-page__answer body-16" data-ref="accordionBody">
            <p> ${faq.answer}</p>
        </div>
    </div>`
}

const categoryTemplate = (cat) => {
    return `<div class="faq-page__category"
        data-category="${cat}" 
    >
        <span class="faq-page__category-title body-16">
            ${cat}
        </span>
        <svg class="icon icon--caret-down" role="presentation" viewBox="0 0 21 11">
            <polyline stroke-width="2" fill="none" stroke="currentColor" 
                points="0.5 0.5 10.5 10.5 20.5 0.5"
            ></polyline>
        </svg>
    </div>`
}



// WEBPACK FOOTER //
// ./src/resources/scripts/components/FaqPage.js